module.exports = __webpack_public_path__ + "static/media/truck.7c67df3f.svg";